import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import MainImg from '../assets/img/signin1.png'
import Icon1 from '../assets/img/Icons/Icons/Icon-01.png'

import Icon2 from '../assets/img/Icons/Icons/Icon-06.png'

import Icon3 from '../assets/img/Icons/Icons/Icon-02.png'
import Icon4 from '../assets/img/Icons/Icons/Icon-07.png'

import Icon5 from '../assets/img/Icons/Icons/Icon-03.png'
import Icon6 from '../assets/img/Icons/Icons/Icon-08.png'


import Icon7 from '../assets/img/Icons/Icons/Icon-04.png'
import Icon8 from '../assets/img/Icons/Icons/Icon-09.png'

import Icon9 from '../assets/img/Icons/Icons/Icon-05.png'
import Icon10 from '../assets/img/Icons/Icons/Icon-10.png'

import Barside from '../assets/img/Icons/Icons/Icon-17.png'
const footer = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light fixed-bottom bg-dark pt-5 footer-bottom">

                <div className=" navbar-collapse" id="navbarSupportedContent">
                    <div className="d-flex">
                        <Link to="/Coupens" className="footer-text">
                        <div className="footer-sm-div text-center">
                            <div className="card-f">
                                <img src={Icon1} alt="Card Back" />
                                <img src={Icon2} className="img-top-f" alt="Card Front" />
                            </div>
                            <p className="font-weight-bold mb-2 mt-1">Coupons</p>
                        </div>
                        </Link>
                        <Link to="/Reaward" className="footer-text">
                        <div className="footer-sm-div text-center">
                            <div className="card-f">
                                <img src={Icon3} alt="Card Back" />
                                <img src={Icon4} className="img-top-f" alt="Card Front" />
                            </div>
                            <p className="font-weight-bold mb-2 mt-1">Rewards</p>
                        </div>
                        </Link>
                        
                        <Link to="/List" className="footer-text">
                        <div className="footer-sm-div text-center">
                            <div className="card-f">
                                <img src={Icon5} alt="Card Back" />
                                <img src={Icon6} className="img-top-f" alt="Card Front" />
                            </div>
                            <p className="font-weight-bold mb-2 mt-1">List</p>
                        </div>
                        
                        </Link>
                        <Link to="/CardNew" className="footer-sm-div text-center footer-text">
                            <div className="card-f">
                                <img src={Icon7} alt="Card Back" />
                                <img src={Icon8} className="img-top-f" alt="Card Front" />
                            </div>
                            <p className="font-weight-bold mb-2">Card</p>
                        </Link>
                        <Link to="/Profile" className="footer-sm-div text-center footer-text">
                            <div className="card-f">
                                <img src={Icon9} alt="Card Back" />
                                <img src={Icon10} className="img-top-f" alt="Card Front" />
                            </div>
                            <p className="font-weight-bold mb-2">Account</p>
                        </Link>

                    </div>
                </div>
            </nav>

        </div>
    )
}

export default footer;


// https://www.tutorialrepublic.com/faq/how-to-change-image-on-hover-with-css.php